import { render, staticRenderFns } from "./GeneralForm.vue?vue&type=template&id=58c8b186"
import script from "./GeneralForm.vue?vue&type=script&lang=js"
export * from "./GeneralForm.vue?vue&type=script&lang=js"
import style0 from "./GeneralForm.vue?vue&type=style&index=0&id=58c8b186&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports